import React, { useContext, useEffect, useState } from 'react';
import { useApi } from './ApiContext';
import { useAuth } from './AuthContext';
import { urls } from './config';

export const AccountContext = React.createContext();

export const useAccount = () => useContext(AccountContext);

export const AccountProvider = ({ children }) => {

    const { basicQuery } = useApi();
    const { token, roles, logout, isLoggedIn } = useAuth();

    const [accounts, setAccounts] = useState([]);

    useEffect(()=>{

        const processAccounts = (data, responseCode) => {
            if (responseCode === 401){
                logout();
            }
            else{
                setAccounts(data);
            }
        }

        if (isLoggedIn && token && roles && (roles.includes("Admin") || roles.includes("GlobalAdmin"))){
            basicQuery(urls.account + "Account/get-account-list", token, processAccounts, "89999");
        }
            
    },[basicQuery, token, roles, logout, isLoggedIn]);

    return (
        <AccountContext.Provider
            value={{
                accounts
            }}
        >
            {children}
        </AccountContext.Provider>
    );
};
